import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { ReportHistoryResponse } from './get-report.type';

export const getReportSatViewService = async () => {
  const { response, data } = await BACKEND.get<ReportHistoryResponse>(ENDPOINT.REPORT_SAT_V2);
  return {
    response,
    summary: data,
  };
};
